import styled from "@emotion/styled"
import { Flex } from "@chakra-ui/react"

export const Root = styled(Flex)`
  position: absolute;
  height: 100%;
  width: 100%;
  justify-content: center;
`

export const ScreensContainer = styled(Flex)`
  height: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`

export const ButtonsContainer = styled(Flex)`
z-index: 10001 !important;
 position: absolute;
  }
`

export const ContainerMuteUserButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
`
